<script setup lang="ts">
import { EmptyProps } from "./Empty.props"
import { iconsSrcMapping } from "./Empty.iconMapping"
import { customPaths } from "~/utils/constants"

const props = defineProps<EmptyProps>()

const { t } = useI18n()
const route = useRoute()
const dayjs = useDayjs()

const startDate = dayjs(props.startDate).format("DD/MM/YYYY")
const endDate = dayjs(props.endDate).format("DD/MM/YYYY")

const title = computed<string>(() => {
  if (props.isPromoExpired) {
    if (props.product) {
      return t(`textBlock.empty.${props.type}.expiredTitle`, {
        product: `${props.product}`,
        endDate: endDate ?? ""
      })
    } else {
      return t(`textBlock.empty.${props.type}.expiredTitleNoProduct`, {
        endDate: endDate ?? ""
      })
    }
  } else if (props.isPromoNotStarted) {
    if (props.product) {
      return t(`textBlock.empty.${props.type}.promoNotStartedTitle`, {
        product: `${props.product}`,
        startDate: startDate ?? ""
      })
    } else {
      return t(`textBlock.empty.${props.type}.promoNotStartedTitleNoProduct`, {
        startDate: startDate ?? ""
      })
    }
  }

  return t("textBlock.empty.productNotFound.title", {
    product: route?.query?.query ?? props.product
  })
})

const description = computed<string>(() => {
  if (props.isPromoExpired) {
    return t(`textBlock.empty.${props.type}.expiredDescription`)
  } else if (props.isPromoNotStarted) {
    return t(`textBlock.empty.${props.type}.promoNotStartedDescription`)
  }

  return t("textBlock.empty.productNotFound.description")
})
</script>

<template>
  <div
    class="
      empty-text-block
      flex
      w-full
      flex-col
      items-center
      gap-4
      py-8
      text-center
    "
  >
    <UtilsIcon v-bind="iconsSrcMapping[type]" />

    <UtilsMarkdown
      class="elephant-bold md:mammoth-bold markdown__strong-green-main"
      :content="title"
    />

    <UtilsMarkdown class="pig text-slate-main" :content="description" />

    <UtilsButton
      v-if="type === 'promotionExpired'"
      :to="customPaths.promotions"
      :text="$t('textBlock.empty.promotionExpired.button')"
    />

    <UtilsButton
      v-if="type === 'productNotFound'"
      :to="customPaths.requestNewProduct"
      theme="outlined-green"
      :text="$t('textBlock.empty.productNotFound.button')"
    />
  </div>
</template>
